export interface Environment {
  isMobile: boolean;
  platform: 'instagram' | 'tiktok' | 'discord' | 'facebook' | null;
  os: 'ios' | 'android' | null;
  userAgent: string;
}

/**
 * Detects the user's environment including mobile status, platform, and OS
 */
export function detectEnvironment(): Environment {
  const ua = navigator.userAgent;

  // Mobile detection
  const isMobile = /Mobile|Android|iPhone|iPad/i.test(ua);

  // Platform detection (embedded browsers)
  let platform: Environment['platform'] = null;
  if (/Instagram/i.test(ua)) platform = 'instagram';
  else if (/TikTok/i.test(ua)) platform = 'tiktok';
  else if (/Discord/i.test(ua)) platform = 'discord';
  else if (/FB|Facebook/i.test(ua)) platform = 'facebook';

  // OS detection (for fallback)
  let os: Environment['os'] = null;
  if (/iPhone|iPad|iPod/i.test(ua)) os = 'ios';
  else if (/Android/i.test(ua)) os = 'android';

  return { isMobile, platform, os, userAgent: ua };
}

/**
 * Maps platform/provider names to Clerk OAuth strategy names
 * Note: 'email_link' is available but not used in auto-detection
 */
export function getClerkStrategy(provider: string): string | null {
  const strategyMap: Record<string, string> = {
    instagram: 'oauth_instagram',
    tiktok: 'oauth_tiktok',
    discord: 'oauth_discord',
    facebook: 'oauth_facebook',
    google: 'oauth_google',
    apple: 'oauth_apple',
    email: 'email_link', // Magic link strategy (fallback only)
  };
  return strategyMap[provider.toLowerCase()] || null;
}
